<template>
    <div class="flag">
        <div class="fixed flex center middle between">
            <div class="content flex-1">
                <p>
                    Você está acessando uma versão de <b>demonstração do sistema</b>!
                </p>
                <p class="margin-top-s">
                    <b>Você ganhou 7 dias grátis para testar.</b> Faça seu cadastro e comece a útilizar ainda hoje <a href="https://lucreihoje.com.br/#price" target="_blank"><b>clique aqui!</b></a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'subscription-flag',
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.flag {
    margin-bottom: 60px
}
.fixed {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 80px;
    width: 100%;
    color: #333;
    background: #68d588;
    height: auto;


    .content {
        width: 100%;
        text-align: left;
        font-size: 14px;
        min-height: 70px;
        height: auto;
        padding: 15px 90px 5px 5px;
        text-align: center;
    }

    .icon {
        margin-left: 90px;
        width: 70px;
        padding: 5px;
        font-size: 36px;
    }
}

@media screen and (max-width: 1024px) {
   .flag {
        margin-bottom: 110px;
    }
  .fixed {
    left:0px;
    .content {
        padding: 15px 30px 10px 10px;
    }
  }

}
</style>

<style>

@media screen and (max-width: 1024px) {
    .sidebar.isdemo {
        top: 115px !important;
    }
}
</style>
